/* eslint-disable @typescript-eslint/no-use-before-define */
import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import template from './template.html'
import CustomEmbedBlockWrapper from './customEmbedBlockWrapper'

export default angular
  .module('ellipsis.featuredMediaCustomEmbed', [])
  .directive('featuredMediaCustomEmbed', ['$ngRedux', directive])

function directive(reduxStore) {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      customEmbedTypes: '<',
      embedData: '<',
      setEmbedData: '&',
    },
    controller: [Controller],
    link: Link(reduxStore),
  }
}

function Link(reduxStore) {
  return (scope, el) => {
    const rootElement = el[0]
    scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootElement))
    ReactDOM.render(
      <Provider store={reduxStore}>
        <CustomEmbedBlockWrapper
          embed={scope.vm.embedData}
          setEmbed={scope.vm.setEmbedData}
          customEmbedTypes={scope.vm.customEmbedTypes}
        />
      </Provider>,
      rootElement
    )
  }
}

function Controller() {}
